import $ from 'jquery';
import { getCurrentDataLayer, addToDataLayerForLinks } from '../common/helper';

export function init() {
  $('.js-tracking-logout-link').on('click', onLogOut);
}

function onLogOut(event) {
  var trackingData = {
    event: 'logout',
    visitorID: getCurrentDataLayer().visitorID || ''
  };

  addToDataLayerForLinks(event, trackingData);
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/tracking/layout/logout.js
 **/